module.exports = __webpack_public_path__ + "static/media/29BDOS2.cb155653.jpg";